// Le texte d'une offre, rendu lisible. Module PUR et sans dépendance : le
// poll s'en sert sur chaque description lue (adapters/description.ts), et
// l'écran l'applique aussi aux offres déjà en base, qu'aucun poll ne relit.

/** Pieds de page que des sites collent sous chaque description et qu'aucun
 *  conteneur n'écarte : le formulaire d'alerte de jobs.lu (« Please enter
 *  your email / Email Next »), précédé de ses listes « Related Sectors » et
 *  « Related Locations » (le lieu est déjà lu ailleurs). Mesure du
 *  2026-10-12 : 1 029 offres ouvertes de radar.db finissaient ainsi, et ce
 *  texte partait aussi au scoring. Tout ce qui suit le début du pied part.
 *
 *  Chaque motif est ANCRÉ sur la fin exacte du formulaire (« Email Next » en
 *  dernière ligne). Un motif qui coupait dès « Please enter your email »
 *  amputait toute offre qui écrit « How to apply: please enter your email… »
 *  au milieu de son texte (issue #153). */
const FIN_FORMULAIRE = String.raw`Please enter your email\s*\n\s*Email\s+Next\s*$`
const PIEDS_DE_PAGE = [
  new RegExp(String.raw`\n[ \t]*Related Sectors:[\s\S]*` + FIN_FORMULAIRE, 'i'),
  new RegExp(String.raw`\n[ \t]*` + FIN_FORMULAIRE, 'i'),
]

/**
 * Une description lisible : retours chariot unifiés, espaces de chaque ligne
 * resserrés, jamais plus d'une ligne vide de suite, pieds de page connus
 * retirés. Les pages scrapées rendaient des trous de dix lignes vides.
 * Pure et sans dépendance : l'écran l'applique aussi aux offres déjà en base.
 */
export function nettoyerDescription(texte: string): string {
  let t = ('\n' + texte).replace(/\r\n?/g, '\n')
  for (const pied of PIEDS_DE_PAGE) t = t.replace(pied, '')
  return t
    .split('\n')
    .map((ligne) => ligne.replace(/[ \t\u00a0]+/g, ' ').trim())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}
